import React from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

export default function SiteLayout({ children }) {
    return (
        <div className="min-h-screen bg-pearl text-navy flex flex-col">
            <Navigation />
            <main className="flex-1">{children}</main>
            <Footer />
            <WhatsAppButton />
        </div>
    );
}
